import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Box } from '../../../../../components/atoms/Box';
import { Typography } from '../../../../../components/atoms/Typography';

export const ContentWrapperBox = styled(Box)`
  overflow-y: auto;
  overflow-x: auto;
  height: 60vh;
`;

export const SubHeadingWrapper = styled(Typography)`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const SwitchGrid = styled(Grid)`
  justify-content: center;
  align-items: center;
`;

export const ClientContractGrid = styled(Grid)`
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 10px;
`;

export const StyledButtonGrid = styled(Grid)`
  margin-top: 20px;
  margin-left: 10px;
`;